module.exports = __webpack_public_path__ + "static/media/science-BEAKER.3cf173fb.png";